import React, { Component } from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Pressure as PressureAction } from '~/actions';
import { PressureFilters, ContentSection, PressureSimulate, SeepageSection } from '~/components';
import ContentData from '~/hoc/ContentData';
import moment from '~/_moment';

const Option = Select.Option;

class SeepageSimulation extends Component {
  state = {
    frameIndex: 0,
  };

  UNSAFE_componentWillMount() {
    this.props.loadPressure(moment().format('YYYY-MM-DD'));
  }

  componentWillUnmount() {
    this.props.resetPressure();
  }

  onDateChange = (val) => {
    this.setState({ frameIndex: val });
  };

  render() {
    const {
      profile: {
        site_name: siteName,
        pressure: { enable: isPressureEnable, dam_section: damSection },
        firstRun,
        seepage: seepageProfile,
      },
      pressure,
      seepage,
      loadPressure,
      handleChangeDate,
    } = this.props;

    const { frameIndex } = this.state;

    return (
      isPressureEnable && (
        <ContentSection>
          <Helmet>
            <title>ระบบประมวลผลอัตราการรั่วซึม</title>
          </Helmet>
          <ContentData title="ประมวลผลอัตราการรั่วซึม" isLoading={pressure.isloading}>
            <PressureFilters
              siteName={siteName}
              dateFormat="YYYY-MM-DD"
              timeFormat="HH:mm"
              dateValue={pressure.date}
              showTimePicker={false}
              isPressureloading={pressure.isloading}
              handleLoadData={() => loadPressure(pressure.date)}
              handleChangeDate={handleChangeDate}
              disabledDate={moment(firstRun).subtract(1, 'days')}
            />

            {seepage.data && (
              <div>
                <Select value={frameIndex} onChange={this.onDateChange}>
                  {pressure.data &&
                    pressure.data.map((rec, index) => (
                      <Option key={rec.time} value={index}>
                        {rec.time}
                      </Option>
                    ))}
                </Select>
              </div>
            )}

            <PressureSimulate
              damSectionImage={damSection}
              pressureData={pressure}
              isLoading={pressure.isloading}
              forceRenderIndex={frameIndex}
            />

            <SeepageSection
              seepage={seepage}
              seepageProfile={seepageProfile}
              frameIndex={frameIndex}
            />
          </ContentData>
        </ContentSection>
      )
    );
  }
}

export default connect(
  ({ Seepage, DamProfile, Pressure }) => ({
    seepage: Seepage,
    profile: DamProfile,
    pressure: Pressure,
  }),
  {
    loadPressure: PressureAction.loadPressureData,
    handleChangeDate: PressureAction.changeDate,
    resetPressure: PressureAction.resetPressureData,
  },
)(SeepageSimulation);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeepageSimulation/index.js